import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  private apiUrl = environment.api_url;
  private httpClient = inject(HttpClient);

  get<T>(
    route: string,
    params?: HttpParams,
    responseType: 'json' | 'text' | 'blob' | 'arraybuffer' = 'json'
  ): Observable<T extends object ? T : any> {
    return this.httpClient.get<T extends object ? T : any>(this.apiUrl + route, {
      params,
      responseType: responseType as any
    });
  }


  post<T>(
    payload: any,
    route: string,
    params?: HttpParams,
    responseType: 'json' | 'text' | 'blob' | 'arraybuffer' = 'json'
  ): Observable<T extends object ? T : any> {
    return this.httpClient.post<T extends object ? T : any>(this.apiUrl + route, payload, {
      params,
      responseType: responseType as any
    });
  }

  put(payload: any, route: string) {
    return this.httpClient.put(this.apiUrl + route, payload);
  }

  delete(route: string){
    return this.httpClient.delete(this.apiUrl + route);
  }

  downloadFile(route: string): Observable<Blob> {
    return this.httpClient.get(this.apiUrl + route, { responseType: 'blob' });
  }
}
